<template>
    <div class="product__item-grid">
        <hosting-plan
            v-if="hostingPlans && selectedType === 'webhosting'"
            v-for="hostingPlan in hostingPlans"
            :key="hostingPlan.name"
            :productPlan="hostingPlan"
            :domain="domain"
        />

        <vps-plan
            v-if="canAccessVps && vpsPlans && selectedType === 'vps'"
            v-for="vpsPlan in vpsPlans"
            :key="vpsPlan.name"
            :productPlan="vpsPlan"
            :domain="domain"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HostingPlan from './HostingPlan.vue';
import VpsPlan from '../vps/VpsPlan.vue';

export default {
    components: {
        HostingPlan,
        VpsPlan
    },
    props: {
        domain: Object,
        selectedType: String
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    computed: {
        ...mapGetters({
            hostingPlans: 'products/hostingPlans',
            vpsPlans: 'products/vpsPlans'
        }),

        /**
         * Check if VPS functionality is enabled.
         *
         * @return {boolean}
         */
        canAccessVps() {
            return process.env.VUE_APP_VPS_ENABLED === 'true';
        }
    }
};
</script>
